/**
 * Escrituras adicionales usadas por el módulo de capacitación (sacerdocio / núcleo).
 * Texto canónico en español; las mismas entradas existen en scriptures.training.en.ts con id idéntico.
 */
import type { Scripture } from './scriptures';
import { core3PriesthoodScripturesEs } from './scriptures.training.core3.es';
import { deacon1TrainingScripturesEs } from './scriptures.training.deacon1.es';
import { deacon2TrainingScripturesEs } from './scriptures.training.deacon2.es';
import { teacher2TrainingScripturesEs } from './scriptures.training.teacher2.es';
import { priest1TrainingScripturesEs } from './scriptures.training.priest1.es';
import { priest2TrainingScripturesEs } from './scriptures.training.priest2.es';
import { elder1TrainingScripturesEs } from './scriptures.training.elder1.es';
import { elder2TrainingScripturesEs } from './scriptures.training.elder2.es';
import { highPriest1TrainingScripturesEs } from './scriptures.training.highPriest1.es';
import { highPriest2TrainingScripturesEs } from './scriptures.training.highPriest2.es';
import { manualTrainingScripturesEs } from './scriptures.training.manual.es';

export const scripturesTrainingEs: Scripture[] = [
  {
    id: 'mosiah-2-17',
    reference: 'Mosíah 2:17',
    text: 'Y he aquí, os digo estas cosas para que aprendáis sabiduría; para que sepáis que cuando os halláis al servicio de vuestros semejantes, solo estáis al servicio de vuestro Dios.',
    verses: [
      {
        verse: 17,
        text: 'Y he aquí, os digo estas cosas para que aprendáis sabiduría; para que sepáis que cuando os halláis al servicio de vuestros semejantes, solo estáis al servicio de vuestro Dios.',
      },
    ],
    context: 'El rey Benjamín enseña que servir a los demás es servir a Dios.',
  },
  {
    id: 'dc-1-30',
    reference: 'Doctrina y Convenios 1:30',
    text: 'Y también, para que aquellos a quienes se dieron estos mandamientos tuviesen el poder para establecer los cimientos de esta iglesia y de hacerla salir de la obscuridad y de las tinieblas, la única iglesia verdadera y viviente sobre la faz de toda la tierra, con la cual yo, el Señor, estoy bien complacido, hablando a la iglesia colectiva y no individualmente,',
    verses: [
      {
        verse: 30,
        text: 'Y también, para que aquellos a quienes se dieron estos mandamientos tuviesen el poder para establecer los cimientos de esta iglesia y de hacerla salir de la obscuridad y de las tinieblas, la única iglesia verdadera y viviente sobre la faz de toda la tierra, con la cual yo, el Señor, estoy bien complacido, hablando a la iglesia colectiva y no individualmente,',
      },
    ],
    context: 'El Señor declara la restauración de Su Iglesia en los últimos días.',
  },
  {
    id: 'dc-76-22',
    reference: 'Doctrina y Convenios 76:22',
    text: 'Y ahora, después de los muchos testimonios que se han dado de él, este es el testimonio, el último de todos, que nosotros damos de él: ¡Que vive!',
    verses: [
      {
        verse: 22,
        text: 'Y ahora, después de los muchos testimonios que se han dado de él, este es el testimonio, el último de todos, que nosotros damos de él: ¡Que vive!',
      },
    ],
    context: 'Testimonio de José Smith y Sidney Rigdon sobre Jesucristo tras la visión de la gloria celestial.',
  },
  {
    id: 'articles-of-faith-1-6',
    reference: 'Artículos de Fe 1:6',
    text: 'Creemos en la misma organización que existió en la Iglesia Primitiva, a saber: apóstoles, profetas, pastores, maestros, evangelistas, etc.',
    verses: [
      {
        verse: 6,
        text: 'Creemos en la misma organización que existió en la Iglesia Primitiva, a saber: apóstoles, profetas, pastores, maestros, evangelistas, etc.',
      },
    ],
    context: 'La Iglesia de Jesucristo de los Santos de los Últimos Días está organizada según el orden del Evangelio.',
  },
  {
    id: 'alma-34-32',
    reference: 'Alma 34:32',
    text: 'Porque he aquí, esta vida es cuando el hombre debe prepararse para comparecer ante Dios; sí, el día de esta vida es el día en que el hombre debe ejecutar su obra.',
    verses: [
      {
        verse: 32,
        text: 'Porque he aquí, esta vida es cuando el hombre debe prepararse para comparecer ante Dios; sí, el día de esta vida es el día en que el hombre debe ejecutar su obra.',
      },
    ],
    context: 'Amulek enseña que el tiempo de preparación es en esta vida.',
  },
  {
    id: 'dc-20-77-79',
    reference: 'Doctrina y Convenios 20:77, 79',
    text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este pan para las almas de todos los que participen de él, para que lo coman en memoria del cuerpo de tu Hijo, y testifiquen ante ti, oh Dios, Padre Eterno, que están dispuestos a tomar sobre sí el nombre de tu Hijo, y a recordarle siempre, y a guardar sus mandamientos que él les ha dado, para que siempre puedan tener su Espíritu consigo. Amén. Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este vino para las almas de todos los que lo beban, para que lo hagan en memoria de la sangre de tu Hijo, que por ellos se derramó; para que testifiquen ante ti, oh Dios, Padre Eterno, que siempre se acuerdan de él, para que puedan tener su Espíritu consigo. Amén.',
    verses: [
      {
        verse: 77,
        text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este pan para las almas de todos los que participen de él, para que lo coman en memoria del cuerpo de tu Hijo, y testifiquen ante ti, oh Dios, Padre Eterno, que están dispuestos a tomar sobre sí el nombre de tu Hijo, y a recordarle siempre, y a guardar sus mandamientos que él les ha dado, para que siempre puedan tener su Espíritu consigo. Amén.',
      },
      {
        verse: 79,
        text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este vino para las almas de todos los que lo beban, para que lo hagan en memoria de la sangre de tu Hijo, que por ellos se derramó; para que testifiquen ante ti, oh Dios, Padre Eterno, que siempre se acuerdan de él, para que puedan tener su Espíritu consigo. Amén.',
      },
    ],
    context: 'Oraciones sacramentales del pan y del vino (agua) según Doctrina y Convenios 20.',
  },
  {
    id: 'moroni-4-5',
    reference: 'Moroni 4–5',
    text: 'La forma en que sus élderes y presbíteros administraban la carne y la sangre de Cristo a la iglesia; y las administraban de acuerdo con los mandamientos de Cristo; por tanto, sabemos que la manera es correcta; y el élder o el presbítero las administraba. Y se arrodillaban con la iglesia, y oraban al Padre en el nombre de Cristo, diciendo: Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este pan para las almas de todos los que participen de él, para que lo coman en memoria del cuerpo de tu Hijo, y testifiquen ante ti, oh Dios, Padre Eterno, que están dispuestos a tomar sobre sí el nombre de tu Hijo, y a recordarle siempre, y a guardar sus mandamientos que él les ha dado, para que siempre puedan tener su Espíritu consigo. Amén. La manera de administrar el vino. He aquí, tomaban la copa y decían: Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este vino para las almas de todos los que lo beban, para que lo hagan en memoria de la sangre de tu Hijo, que por ellos se derramó; para que testifiquen ante ti, oh Dios, Padre Eterno, que siempre se acuerdan de él, para que puedan tener su Espíritu consigo. Amén.',
    verses: [
      {
        verse: 1,
        text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este pan para las almas de todos los que participen de él, para que lo coman en memoria del cuerpo de tu Hijo, y testifiquen ante ti, oh Dios, Padre Eterno, que están dispuestos a tomar sobre sí el nombre de tu Hijo, y a recordarle siempre, y a guardar sus mandamientos que él les ha dado, para que siempre puedan tener su Espíritu consigo. Amén.',
      },
      {
        verse: 2,
        text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este vino para las almas de todos los que lo beban, para que lo hagan en memoria de la sangre de tu Hijo, que por ellos se derramó; para que testifiquen ante ti, oh Dios, Padre Eterno, que siempre se acuerdan de él, para que puedan tener su Espíritu consigo. Amén.',
      },
    ],
    context: 'Oraciones del Libro de Mormón sobre el pan y el vino (agua) en la Santa Cena.',
  },
  {
    id: 'moroni-6-1-4',
    reference: 'Moroni 6:1–4',
    text: 'Y ahora hablo concerniente al bautismo. He aquí, eran bautizados élderes, presbíteros y maestros; y no eran bautizados a menos que dieran frutos apropiados para manifestar que eran dignos de ello. Ni tampoco recibían a nadie para el bautismo, a menos que viniese con un corazón quebrantado y un espíritu contrito, y testificase a la iglesia que verdaderamente se había arrepentido de todos sus pecados. Y a nadie recibían para el bautismo, a menos que tomara sobre sí el nombre de Cristo, teniendo la determinación de servirle hasta el fin. Y después que habían sido recibidos por el bautismo, y el poder del Espíritu Santo había obrado en ellos y los había purificado, eran contados entre los del pueblo de la iglesia de Cristo; y se inscribían sus nombres, a fin de que se hiciese memoria de ellos y fuesen nutridos por la buena palabra de Dios, para guardarlos en la vía correcta, para conservarlos continuamente atentos a orar, confiando solamente en los méritos de Cristo, que era el autor y perfeccionador de su fe.',
    verses: [
      {
        verse: 1,
        text: 'Y ahora hablo concerniente al bautismo. He aquí, eran bautizados élderes, presbíteros y maestros; y no eran bautizados a menos que dieran frutos apropiados para manifestar que eran dignos de ello.',
      },
      {
        verse: 2,
        text: 'Ni tampoco recibían a nadie para el bautismo, a menos que viniese con un corazón quebrantado y un espíritu contrito, y testificase a la iglesia que verdaderamente se había arrepentido de todos sus pecados.',
      },
      {
        verse: 3,
        text: 'Y a nadie recibían para el bautismo, a menos que tomara sobre sí el nombre de Cristo, teniendo la determinación de servirle hasta el fin.',
      },
      {
        verse: 4,
        text: 'Y después que habían sido recibidos por el bautismo, y el poder del Espíritu Santo había obrado en ellos y los había purificado, eran contados entre los del pueblo de la iglesia de Cristo; y se inscribían sus nombres, a fin de que se hiciese memoria de ellos y fuesen nutridos por la buena palabra de Dios, para guardarlos en la vía correcta, para conservarlos continuamente atentos a orar, confiando solamente en los méritos de Cristo, que era el autor y perfeccionador de su fe.',
      },
    ],
    context: 'Moroni describe el bautismo y el cuidado de los miembros en la iglesia de Cristo.',
  },
  {
    id: 'moroni-6-5-6',
    reference: 'Moroni 6:5–6',
    text: 'Y la iglesia se reunía a menudo para ayunar y orar, y para hablar unos con otros concerniente al bienestar de sus almas. Y se reunían con frecuencia para participar del pan y vino, en memoria del Señor Jesús.',
    verses: [
      {
        verse: 5,
        text: 'Y la iglesia se reunía a menudo para ayunar y orar, y para hablar unos con otros concerniente al bienestar de sus almas.',
      },
      {
        verse: 6,
        text: 'Y se reunían con frecuencia para participar del pan y vino, en memoria del Señor Jesús.',
      },
    ],
    context: 'La iglesia primitiva del Libro de Mormón se reunía con frecuencia para adorar y participar de la Santa Cena.',
  },
  ...core3PriesthoodScripturesEs,
  ...deacon1TrainingScripturesEs,
  ...deacon2TrainingScripturesEs,
  ...teacher2TrainingScripturesEs,
  ...priest1TrainingScripturesEs,
  ...priest2TrainingScripturesEs,
  ...elder1TrainingScripturesEs,
  ...elder2TrainingScripturesEs,
  ...highPriest1TrainingScripturesEs,
  ...highPriest2TrainingScripturesEs,
  ...manualTrainingScripturesEs,
];
